import { Link } from "react-router-dom";
import ContentLayout from "../components/layout/ContentLayout";
import MyBreadcrumb from "../components/layout/MyBreadcrumb";
import { CgProfile } from "react-icons/cg";
import { RiUserSettingsLine } from "react-icons/ri";

export default function Settings() {
  return (
    <ContentLayout
      header={
        <>
          <h1>Settings</h1>
          <MyBreadcrumb />
          <div className="settings-items">
            <Link to="account" className="settings-item">
              <CgProfile size={24} />
              <p>Your Account</p>
            </Link>
            <Link to="roles" className="settings-item">
              <RiUserSettingsLine size={24} />
              <p>Account Roles</p>
            </Link>
          </div>
        </>
      }
    ></ContentLayout>
  );
}
